<template>
  <a-table
    ref="table"
    size="middle"
    bordered
    rowKey="sort"
    :columns="columns"
    :dataSource="dataSource"
    :pagination="ipagination"
    :loading="loading"
    @change="handleTableChange">
  </a-table>
</template>

<script>
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
export default {
  name: 'financePage',
  mixins:[JeecgListMixin],
  data() {
    return {
      // 表头
      columns: [
        { title: '排名', align:"left", dataIndex: 'sort', width: 50, },
        { title: '客户名称', align:"left", dataIndex: 'name' },
        { title: '欠款金额', dataIndex: 'amount'},
      ],
      url: {
        list: "/saleAnylize/getOwnMoneySortPageA",
      },
    }
  },
}
</script>

<style scoped>

</style>